const ICLOSED_URL = 'https://app.iclosed.io/e/usinealead/rdv-45-min-votre-business-votre-besoin';

const points = [
  {
    number: '01',
    title: 'Un diagnostic terrain, pas une slide',
    body: 'Je regarde votre site, vos offres, votre marché. Pas de template générique. Je vous dis exactement ce qui bloque vos leads — et ce qu\'on peut corriger en 30 jours.',
  },
  {
    number: '02',
    title: '20 ans de business réel, pas de théorie',
    body: 'J\'ai accompagné plus de 100 PME et indépendants. J\'ai vu tous les profils. Je sais ce qui marche dans votre secteur et ce qui ne marche pas — avant même de commencer.',
  },
  {
    number: '03',
    title: 'Un système qui tourne sans vous',
    body: 'L\'objectif n\'est pas de vous occuper à faire du marketing. C\'est de mettre en place une machine qui génère des RDV pendant que vous faites votre métier.',
  },
  {
    number: '04',
    title: 'Des résultats mesurables en 90 jours',
    body: '+47% de leads qualifiés en moyenne. Ce n\'est pas une promesse marketing — c\'est la moyenne de nos clients sur les 90 premiers jours de collaboration.',
  },
];

export default function WhyItWorks() {
  return (
    <section
      className="w-full pt-6 md:pt-8 pb-14 md:pb-20"
      style={{ background: '#0d0d0d', borderTop: '1px solid rgba(255,255,255,0.06)' }}
    >
      <div className="max-w-7xl mx-auto px-8 md:px-16">

        {/* Section label */}
        <p
          className="text-xs font-bold tracking-[0.25em] uppercase mb-10"
          style={{ color: 'rgba(200,146,42,0.8)' }}
        >
          Pourquoi ça marche
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">

          {/* Left — photo + quote */}
          <div className="flex flex-col gap-8">
            <div className="relative">
              {/* Gold accent line */}
              <div
                className="absolute left-0 top-0 bottom-0 w-1 rounded-full"
                style={{ background: '#C8922A' }}
              />
              {/* Photo */}
              <div className="pl-6">
                <div
                  className="w-full overflow-hidden"
                  style={{
                    borderRadius: '4px',
                    maxWidth: '420px',
                    aspectRatio: '4/5',
                  }}
                >
                  <img
                    src="https://storage.readdy-site.link/project_files/23ada950-d962-4505-8038-df56bbfe1d70/99470d9e-562d-4f81-ae27-5cd1b51f76ea_marc_signorel.jpg?v=91f1d4165db8778765c2fd93fcf5664b"
                    alt="Marc Signorel — fondateur Usine à Leads"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
            </div>

            {/* Identity block */}
            <div className="flex flex-col gap-2 pl-6">
              <span
                className="font-black text-xl text-white"
                style={{ letterSpacing: '-0.02em' }}
              >
                Marc Signorel
              </span>
              <span
                className="text-sm font-medium"
                style={{ color: '#C8922A' }}
              >
                Fondateur — Usine à Leads
              </span>
              <p
                className="text-sm leading-relaxed mt-2 max-w-sm"
                style={{ color: 'rgba(255,255,255,0.45)' }}
              >
                20 ans à accompagner des PME et indépendants sur leur acquisition.
                Ni agence, ni consultant théorique — un praticien qui a vu ce qui marche vraiment.
              </p>
            </div>

            {/* Pull quote */}
            <blockquote
              className="pl-6 border-l-0 mt-2"
              style={{ borderLeft: 'none' }}
            >
              <p
                className="text-lg md:text-xl leading-snug font-black text-white"
                style={{
                  fontFamily: '\'Georgia\', serif',
                  fontStyle: 'italic',
                  letterSpacing: '-0.01em',
                  maxWidth: '380px',
                }}
              >
                &ldquo;Le problème n&apos;est jamais votre offre.
                C&apos;est le système qui est cassé entre vous
                et vos futurs clients.&rdquo;
              </p>
            </blockquote>
          </div>

          {/* Right — 4 points */}
          <div className="flex flex-col gap-8">
            {points.map((pt) => (
              <div
                key={pt.number}
                className="flex gap-6 group"
              >
                {/* Number */}
                <span
                  className="font-black text-3xl leading-none shrink-0 mt-1 transition-colors duration-200"
                  style={{
                    color: 'rgba(200,146,42,0.25)',
                    letterSpacing: '-0.04em',
                    fontFamily: '\'Inter\', sans-serif',
                    minWidth: '2.5rem',
                  }}
                >
                  {pt.number}
                </span>
                {/* Text */}
                <div className="flex flex-col gap-2">
                  <h3
                    className="font-black text-lg text-white leading-snug"
                    style={{ letterSpacing: '-0.02em', fontFamily: '\'Inter\', sans-serif' }}
                  >
                    {pt.title}
                  </h3>
                  <p
                    className="text-sm leading-relaxed"
                    style={{ color: 'rgba(255,255,255,0.5)' }}
                  >
                    {pt.body}
                  </p>
                </div>
              </div>
            ))}

            {/* CTA */}
            <div className="flex flex-col gap-3 pt-4">
              <button
                data-iclosed-link={ICLOSED_URL}
                data-embed-type="popup"
                className="inline-flex items-center justify-center px-8 py-4 font-bold text-base transition-all duration-200 hover:brightness-110 active:scale-95 whitespace-nowrap cursor-pointer w-fit"
                style={{
                  background: '#C8922A',
                  color: '#111111',
                  borderRadius: '4px',
                  letterSpacing: '-0.01em',
                  border: 'none',
                }}
              >
                Accéder au diagnostic — 45 min offertes →
              </button>
              <p className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>
                Sans engagement · On vous dit la vérité même si c&apos;est non
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
